export default __webpack_public_path__ + "static/timetable-e880dbba07ced01312c694445d9bdefa.png";